export function recursiveRemoveProperties(obj: Object, props: string[]) {
  Object.keys(obj).forEach(key => {
    if (props.includes(key)) {
        delete obj[key as keyof Object];
    }
    if (obj[key as keyof Object] && typeof obj[key as keyof Object] === 'object') {
      recursiveRemoveProperties(obj[key as keyof Object], props);
    }
  });
}